import { ReactNode } from "react";
import styles from "./section.module.scss";
import Seprator from "@Components/Seprator";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";

type SectionTypes = {
  title: string;
  children: ReactNode;
  id?: string;
  withSeprator?: boolean;
  showTitleLine?: boolean;
  className?: any;
  dataTestId?: string;
};

const Section = ({
  title,
  children,
  id,
  withSeprator = true,
  showTitleLine = false,
  className = "",
  dataTestId,
}: SectionTypes) => {
  const { isWhitelabel } = useWhitelabel();

  return (
    <section
      data-testid={dataTestId}
      className={formatClassNames(styles.section, className)}
      id={id}
    >
      <h2
        className={formatClassNames(
          styles.title,
          showTitleLine && styles.titleLine,
          isWhitelabel ? "wl-title-font" : "",
        )}
      >
        {title}
      </h2>
      {children}
      {withSeprator && <Seprator noMargin />}
    </section>
  );
};

export default wrapperHOC(Section, {
  componentName: "Section-Global",
  showForChina: true,
});
